'use client';

import { PropsWithChildren, useReducer } from 'react';
import { AccordionContext } from './helpers/AccordionContext';
import { AccordionItemID } from './state/accordionStore.types';
import { defaultState } from './state/accordionStore';
import { accordionStateReducer } from './state/accordionStateReducer';
import { useAccordionReducer } from './hooks/useAccordionReducer';
export { useAccordionItemOpened, useAreAllItemsOpened, useAreAllItemsClosed, useDispatchAccordion } from './hooks/accordionHooks';

/**
 * Provides accordion state management with session storage persistence.
 * Maintains open/closed state across page navigation within the same session.
 */
export const AccordionProviderPersisted = ({
  children,
  defaultOpened = new Set<AccordionItemID>(),
  accordionKey
}: PropsWithChildren<{
  defaultOpened?: Set<AccordionItemID>;
  accordionKey: string;
}>) => {
  const [accordionState, dispatchOpenedItems] = useAccordionReducer(accordionKey);
  return <AccordionContext.Provider value={{
    accordionState,
    dispatchOpenedItems,
    defaultOpened
  }}>
			{children}
		</AccordionContext.Provider>;
};

/**
 * Provides accordion state management without persistence.
 * State is reset when the component unmounts or page is refreshed.
 */
export const AccordionProvider = ({
  children,
  defaultOpened = new Set<AccordionItemID>()
}: PropsWithChildren<{
  defaultOpened?: Set<AccordionItemID>;
}>) => {
  const [accordionState, dispatchOpenedItems] = useReducer(accordionStateReducer, defaultState);
  return <AccordionContext.Provider value={{
    accordionState,
    dispatchOpenedItems,
    defaultOpened
  }}>
			{children}
		</AccordionContext.Provider>;
};